import { LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupSettings" */ './lazyIndex');
});
export var lazyOpenGroupSettings = new LazyImport(lazyModule, function (m) { return m.openGroupSettings; });
//# sourceMappingURL=index.js.map